<template>
  <Timeline class="study-wrap">
    <TimelineItem v-for="(item, index) in catalogList" :key="index">
      <span class="item-dot" slot="dot">
        <span></span>
      </span>
      <div class="study-title" @click="setVisible(item)">
        <div v-if="!item.visible" class="title-icon">
          <!-- <img src="../../../assets/images/v3/icon-plus.png" /> -->
          <span class="iconfont iconanniu2"></span>
        </div>
        <div v-else class="title-icon">
          <!-- <img src="../../../assets/images/v3/icon-minus.png" /> -->
          <span class="iconfont iconzhankai1"></span>
        </div>
        <div class="title-text">
          {{ item.catName }}
        </div>
      </div>
      <transition name="slide-up">
        <div class="study-body" v-show="item.visible">
          <div
            class="study-item"
            v-for="(chapter, chapterIndex) in item.childList"
            :key="chapterIndex"
          >
            <div class="name">{{ chapter.catName }}</div>
            <div class="progress">
              <div class="progress-title">练习进度</div>
              <div class="progress-bar">
                <Progress
                  :percent="chapter.percent"
                  hide-info
                  :stroke-width="8"
                  :stroke-color="['#27a4ff', '#227efa']"
                />
              </div>
              <div class="progress-text">
                {{ chapter.finishExerNum }}/{{ chapter.ExerNum }}
              </div>
            </div>
            <div class="action">
              <router-link
                :to="{
                  name: 'Practice',
                  params: { id: chapter.catId },
                  query: { umcid: defaultCid },
                }"
                target="_blank"
                ><Button type="primary" shape="circle" long
                  >开始练习</Button
                ></router-link
              >
            </div>
          </div>
        </div>
      </transition>
    </TimelineItem>
  </Timeline>
  <!-- <div>
    <dl class="study-list" v-for="(item, index) in catalogList" :key="index">
      <dt class="clearfix" :class="{ active: item.visible }" @click="setVisible(item)">
        <span class="fl">{{ item.catName }}</span>
        <span class="fr">
          <Icon type="ios-arrow-down" />
        </span>
      </dt>
      <transition name="slide-up">
        <dd v-show="item.visible">
          <div
            v-for="(chapter, chapterIndex) in item.childList"
            :key="chapterIndex"
          >
            <span class="am-inline-block">
              {{ chapter.catName }}
              <br />
              <span
                >练习进度：{{ chapter.finishExerNum }}/{{
                  chapter.ExerNum
                }}</span
              >
            </span>
            <p class="fr">
              <router-link
                :to="{
                  name: 'Practice',
                  params: { id: chapter.catId },
                  query: { umcid: umcId },
                }"
                target="_blank"
                ><Button type="primary">开始练习</Button></router-link
              >
            </p>
          </div>
        </dd>
      </transition>
    </dl>
  </div> -->
</template>
<script>
import { siteMixin } from '../../../utils/mixin';
import { study } from '../../../request';
export default {
  mixins: [siteMixin],
  props: {
    cstId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      catalogList: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      study
        .getPracticeCatalogList(
          this.loginUser.userId,
          this.courseId,
          this.cstId
        )
        .then((res) => {
          console.log('chapterCatalog', res);
          if (res.status === 1) {
            this.catalogList = res.data;
            this.catalogList.forEach((item, index) => {
              if (index === 0) {
                this.$set(item, 'visible', true);
              } else {
                this.$set(item, 'visible', false);
              }
              item.childList.forEach((chapter, chapterIndex) => {
                let percent = 0;
                if (chapter.finishExerNum > chapter.ExerNum) {
                  percent = 100;
                } else if (chapter.ExerNum > 0) {
                  percent = parseInt(
                    (chapter.finishExerNum / chapter.ExerNum) * 100
                  );
                }
                this.$set(chapter, 'percent', percent);
              });
            });
          }
        });
    },
    setVisible(item) {
      item.visible = !item.visible;
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../../assets/css/var.less';
@import '../../../assets/css/study.less';
@import '../../../assets/css/iconfont.css';
.study-wrap {
  padding: 0 10px;
  .item-dot {
    width: 15px;
    height: 15px;
    border-radius: 15px;
    border: 1px solid #ddd;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    span {
      width: 7px;
      height: 7px;
      border-radius: 7px;
      background: #eee;
    }
  }
  /deep/.ivu-timeline-item-tail {
    border: 1px dashed #ddd;
  }
}

.study-title {
  margin-top: -6px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  padding-bottom: 16px;
  cursor: pointer;
  .title-icon {
    margin-right: 16px;
  }
  .title-text {
    font-size: 20px;
  }
}
.study-body {
  .study-item {
    display: flex;
    align-items: center;
    border-bottom: 1px dashed #ddd;
    margin-left: 40px;
    padding: 16px 0;
    .name {
      width: 530px;
      font-size: 16px;
      color: #666;
      margin-right: 30px;
      .ellipsis();
    }
    .progress {
      flex: 1;
      display: flex;
      align-items: center;
      &-title {
        font-size: 16px;
        color: #666;
        margin-right: 10px;
      }
      &-bar {
        width: 200px;
        margin-right: 10px;
      }
      &-text {
        flex: 1;
        font-size: 16px;
        color: #666;
      }
    }
    .action {
      width: 100px;
    }
  }
}
</style>
